import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper'
}
const qsAll = {
  sections: 'data-section-type="animated-ticker"',
}



const initSwiper = (section, swiper) => {
  const autoplay = parseInt(section.dataset.autoplay)
  if(typeof swiper.swiper != 'undefined' && swiper.swiper) {
    swiper.swiper.destroy(true, true)
    Array.from(swiper.querySelectorAll('.swiper-slide')).forEach(slide => slide.classList.add('!w-auto'))
  }
  setTimeout(() => {
    const slideWidth = section.querySelector('.swiper-slide').offsetWidth
    swiper.style.width = `${slideWidth * 7.5 + 20 * 7}px`
    Array.from(swiper.querySelectorAll('.swiper-slide')).forEach(slide => slide.classList.remove('!w-auto'))
    const swiperInstance = new Swiper(swiper, {
      slidesPerView: 7.5,
      spaceBetween: 20,
      grabCursor: true,
      a11y: false,
      freeMode: true,
      speed: autoplay * 1000,
      loop: true,
      autoplay: {
        delay: 0.01,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
      },
    })

    // Add click handler for pause/resume functionality
    let resumeTimer = null
    let isPaused = false
    
    swiper.addEventListener('click', () => {
      if (isPaused) return // Prevent multiple clicks while paused
      
      // Stop the autoplay completely
      swiperInstance.autoplay.stop()
      isPaused = true
      
      // Clear any existing timer
      if (resumeTimer) {
        clearTimeout(resumeTimer)
      }
      
      // Resume autoplay after 3 seconds
      resumeTimer = setTimeout(() => {
        // Simulate what happens when user drags - force a slide transition
        const currentIndex = swiperInstance.activeIndex
        const nextIndex = currentIndex + 1 >= swiperInstance.slides.length ? 0 : currentIndex + 1
        
        // Force slide transition with animation to "wake up" the swiper
        swiperInstance.slideTo(nextIndex, autoplay * 1000, false)
        
        // Small delay to let the slide transition complete, then start autoplay
        setTimeout(() => {
          swiperInstance.autoplay.start()
          isPaused = false
        }, 100)
        
      }, 3000)
    })
  }, 500)
}

const initSection = (section) => {
  const swiper = section.querySelector(`[${qs.swiper}]`)
  const slide = swiper.querySelector('.swiper-slide')
  if(slide) {
    const wrapper = swiper.querySelector('.swiper-wrapper')
    for (let index = 0; index < 8; index++) {
      wrapper.appendChild(slide.cloneNode(true))
    }
  }
  
  initSwiper(section, swiper)
  window.addEventListener('resize', () => {
    initSwiper(section, swiper)
  })
}

export const setupAnimatedTickers = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}